











































import {
  defineComponent,
  computed,
  watch,
  ref,
  Ref,
  onMounted,
  onUnmounted,
  getCurrentInstance,
} from '@vue/composition-api';

// 引入组件
import Empty from '@/renderer/components/drawer/components/Empty/index.vue';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import dynamicOpenHandler from '@/renderer/components/drawer/Dynamic/composition/dynamicOpenHandler';

// 引入工具类
import { PAY_SOURCE, openTeamPayDialog } from '@/renderer/scripts/composition/dialogHandler';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { dayjsUsage } from '@/renderer/scripts/utils/dayjsUsage';
import DynamicItem from '../Dynamic/component/DynamicItem.vue';
type OptionType = 'day' | 'week' | 'halfMonth' | 'month' | 'year';
// 动态
export default defineComponent({
  name: 'Workbench',
  components: {
    DynamicItem,
    Empty,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const isPersonal = ref(false);
    const handlerBuy = () => {
      openTeamPayDialog(PAY_SOURCE.DYNAMIC_DRAWER);
    };
    const hasMore = ref(false);
    const filter = ref<OptionType>('week');
    const loading = ref<boolean>(false);
    const dynamicList = ref<SMH.DynamicDataContents[]>([]);
    dynamicOpenHandler();
    const filterOptions = [
      {
        label: i18n_t('今天'),
        value: 'day',
      },
      {
        label: i18n_t('近七天'),
        value: 'week',
      },
      {
        label: i18n_t('近十五天'),
        value: 'halfMonth',
      },
      {
        label: i18n_t('近一个月'),
        value: 'month',
      },
    ];

    // 定时获取协作动态的数据
    let timer: number | undefined;
    // 获取数据
    const getData = async (val: OptionType, isInit: Boolean) => {
      if (isPersonal.value) return;
      const days = dayjsUsage(val, 'YYYY/MM/DD HH:mm:ss');
      const params: SMH.GetWorkbenchDynamicParams = {
        startTime: new Date(days.startTime).toISOString(),
        endTime: new Date(days.endTime).toISOString(),
        onlyGroup: store.getters.userBaseInfo.isTemporary,
      };
      // 只有第一次加载的时候需要又loading动画
      if (isInit) {
        loading.value = true;
      }
      try {
        const { data } = await smh.userAPI.getWorkbenchDynamic(params);
        dynamicList.value = data.contents;
        loading.value = false;
        hasMore.value = data.hasMore || false;
      } catch (err: any) {
        loading.value = false;
        if (err.status === 403) {
          return;
        }
        tips.error(err as MsgError);
      }
    };
    onMounted(() => {
      const { orgExpired } = store.getters;
      // 企业如果过期则先不轮询请求
      if (!orgExpired) {
        getData(filter.value, true);
        timer = window.setInterval(() => {
          getData(filter.value, false);
        }, 20000);
      }
    });
    onUnmounted(() => {
      window.clearInterval(timer);
      timer = undefined;
    });
    watch(
      () => store.getters.editionFlag,
      val => {
        isPersonal.value = val === 'personal';
      },
      {
        immediate: true,
      },
    );
    return {
      handlerBuy,
      isPersonal,
      getData,
      filter,
      filterOptions,
      loading,
      hasMore,
      dynamicList,
    };
  },
});
